import axios from "axios";
import config from "../config/config";
import moment from "moment";
import { utils } from "../utils/utils";

const handleError = (err) => {
  if (err?.response?.status === 401) {
    window.location.href = `/auth/sign-in?returnURL=${window.location.pathname}`;
  } else if (err?.response?.status === 404) {
    window.location.href = "/error/404";
  } else if (err?.response?.status === 400 || err?.response?.status === 422) {
    throw err?.response?.data ?? err;
  } else {
    window.location.href = "/error/500";
  }
};

export const notificationApi = {
  getInvoicingEmailNotifications: (data) => {
    const query = utils.buildQueryString(data);
    return axios(`/api/invoicing-email-notifications?${query}`, {
      baseURL: config.apiURL,
      withCredentials: true,
      method: "get",
    })
      .then((result) => result.data)
      .catch((err) => handleError(err));
  },
  createInvoicingEmailNotification: (data) => {
    data.createdAt = moment().toISOString();
    return axios(`/api/invoicing-email-notifications`, {
      baseURL: config.apiURL,
      withCredentials: true,
      method: "post",
      data,
    })
      .then((result) => result.data)
      .catch((err) => handleError(err));
  },
  updateInvoicingEmailNotifications: (data) => {
    data.updatedAt = moment().toISOString();
    return axios(`/api/invoicing-email-notifications`, {
      baseURL: config.apiURL,
      withCredentials: true,
      method: "put",
      data,
    })
      .then((result) => result.data)
      .catch((err) => handleError(err));
  },
  readyForInvoiceNotification: (data) => {
    return axios(
      `/api/invoicing-email-notifications/ready-for-invoice/${data.id}`,
      {
        baseURL: config.apiURL,
        withCredentials: true,
        method: "get",
        data,
      }
    )
      .then((result) => result.data)
      .catch((err) => handleError(err));
  },
};
